import { combineReducers, applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";

import schema from "./schema";
import products from "./products";
import media from "./media";
import ui from "./ui";
import translation from "./translation";
import field from "./field";
import group from "./group";
import tab from "./tab";
import tag from "./tag";
import collection from "./collection";
// create root reducer
const reducer = combineReducers({ schema, products, ui, media, translation, field, group, tab, tag, collection });
export type RootState = ReturnType<typeof reducer>;

// create redux store
const createStore_ = () => createStore(
    reducer, 
    undefined, 
    applyMiddleware(thunk));

export { createStore_ as createStore };



// WEBPACK FOOTER //
// ./src/state/index.ts